export const pluralize = (count: number, singular: string, plural: string) =>
  `${count} ${count > 1 ? plural : singular}`;

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "heic"];

export const isImageFile = (filename: string) => {
  const extension = filename.includes(".")
    ? filename.split(".").pop()?.toLowerCase()
    : undefined;

  return !!extension && IMAGE_EXTENSIONS.includes(extension);
};
